import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | JSX.Element;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Do you offer mobile window tinting in Glen Burnie?',
      answer: (
        <>
          Yes! We provide convenient <a href="/mobile-tinting" className="text-teal-600 hover:text-teal-700 font-medium">mobile tinting services</a> throughout Glen Burnie and Anne Arundel County. We come to your location for hassle-free service.
        </>
      ),
    },
    {
      question: 'What types of tinting do you offer in Glen Burnie?',
      answer: (
        <>
          We offer <a href="/window-tinting" className="text-teal-600 hover:text-teal-700 font-medium">automotive window tinting</a> (ceramic and standard), <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial building tinting</a>, <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">headlight/taillight tinting</a>, and <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">vehicle decals</a>.
        </>
      ),
    },
    {
      question: 'How long does window tinting take in Glen Burnie?',
      answer: 'Most vehicle tinting jobs take 2-4 hours depending on the vehicle size and type. We offer same-day service for Glen Burnie customers and can schedule around your availability.',
    },
    {
      question: 'What is the cost of window tinting in Glen Burnie?',
      answer: 'Pricing varies based on vehicle type and tint selection. Standard tinting is budget-friendly, while ceramic tint offers premium benefits. Contact us for a free quote tailored to your vehicle.',
    },
    {
      question: 'Is ceramic window tint worth the investment?',
      answer: 'Yes! Ceramic tint blocks significantly more heat, provides 99% UV protection, never fades, and doesn\'t interfere with electronics. It\'s the best choice for comfort, protection, and longevity.',
    },
    {
      question: 'What areas of Glen Burnie do you serve?',
      answer: 'We serve all of Glen Burnie including Marley, Ferndale, Linthicum, Brooklyn Park, Pasadena, and surrounding Anne Arundel County communities. Our mobile service reaches you wherever you are.',
    },
    {
      question: 'Do you provide a warranty on window tinting?',
      answer: 'Yes! All our window tinting services include a lifetime warranty covering peeling, bubbling, fading, and discoloration. We use premium materials and expert installation.',
    },
    {
      question: 'Can you install custom decals on vehicles in Glen Burnie?',
      answer: (
        <>
          Absolutely! We design and install <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">custom vehicle decals</a> for personal vehicles, business fleets, and commercial advertising throughout Glen Burnie.
        </>
      ),
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about our window tinting services in Glen Burnie
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors flex items-center justify-between cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
